// extracted by mini-css-extract-plugin
export default {"screen":"RouteLoadingFallback_screen__ANVCC","label":"RouteLoadingFallback_label__dcPmw"};